import { ComponentProps, MouseEvent, forwardRef } from "react"
import { Button } from "@oysterhr/ui"

export interface SubmitButtonProps extends ComponentProps<typeof Button> {
  hasErrors?: boolean
  isSubmitted?: boolean
}

export const SubmitButton = forwardRef<HTMLButtonElement, SubmitButtonProps>(
  (
    { hasErrors = false, isSubmitted = false, loading = false, disabled = false, ...props },
    ref,
  ) => {
    return (
      <Button
        {...props}
        as="button"
        ref={ref}
        type="submit"
        onMouseDown={(e: MouseEvent) => {
          e.preventDefault()
        }}
        isLoading={loading}
        disabled={(hasErrors && isSubmitted) || loading || disabled}
      />
    )
  },
)
